module.exports = __webpack_public_path__ + "img/asia01.1233dac2.png";